import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const LaborsSummaryStep2 = (params) => {
  return (
    <UserInterface>
      <div className="inner-content row mx-0">
        <div className="container d-flex flex-wrap">
          <div class="row">
            <div class="col-md-6 py-4 pe-2 row mx-0">
              <div class="shadowclass">
                <h4 class="event-alert">
                  Leverage the shift preferences in the employee profiles to
                  quickly create your weekly schedule templates.{" "}
                </h4>
                <img src="/img/step3-1.png" class="img-responsive" />
              </div>
            </div>

            <div class="col-md-6 py-4 ps-2 row mx-0">
              <div class="shadowclass">
                <h4 class="event-alert">
                  Save hours weekly by empowering your employees to view their
                  schedules and manage availability requests from their own
                  computers or phones.{" "}
                </h4>
                <br />
                <p>Employees log in using secure User ID’s and passwords to:</p>
                <ul className="sm-list">
                  <li>- View posted schedules</li>
                  <li>- Request days off</li>
                  <li>- Set preferred shifts</li>
                  <li>- Update availability</li>
                  <li>- Swap shifts with other employees</li>
                </ul>
                <br />
                <p>
                  <strong>
                    Employee scheduling requests are then sent back to the store
                    manager for approval
                  </strong>
                </p>
              </div>

              <div class="shadowclass">
                <h4 class="event-alert">
                  Payroll periods just got a little easier. Let GM automatically
                  calculated your Gross Wages using confirmed shifts from the
                  scheduler then generate salary slips.
                </h4>

                <img src="/img/step3-2.png" class="img-responsive" />
              </div>
            </div>
          </div>

          <div className="row mx-0 w-100">
            <div class="btns d-flex justify-content-end py-4 col-12 px-0">
                <button type="Submit"> Next </button>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default LaborsSummaryStep2;
